import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, InputLabel, MenuItem, RadioGroup, Radio, Select, Typography, } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import { useTranslation } from "react-i18next"
import { useUpdateOrderStatusMutation } from "src/_api/orderApi"
import { useState, useEffect, useMemo } from "react"
import { loadOrderDetails } from "src/_store/entities/orders"
import { useDispatch, useSelector } from "react-redux"
import { ALL_FAILED_ORDER_STATUS, ROLES, ENAAB_ID } from "src/constants"
import { filter } from "lodash"

export default function UpdateOrderStatusDialog({
    open,
    onClose,
    order
}) {
    const { t } = useTranslation()
    const { profile } = useSelector((state) => state.entities.profile);
    const dispatch = useDispatch()

    const orderStatus = ["ORDER_COMPLETED"]
    const orderTaskStatus = ["ORDER_PICKED_UP_FROM_MERCHANT", "ORDER_IN_SHIPPING_COMPANY", "ORDER_COMPLETED"]
    //const orderReturnStatus = ["ORDER_PICKED_UP_FOR_RETURN", "ORDER_IN_SHIPPING_COMPANY", "ORDER_COMPLETED"]

    const [updateOrderStatus, { isLoading, isSuccess, error, reset }] = useUpdateOrderStatusMutation()

    const [selectStatus, setSelectStatus] = useState('')
    const [paymentMethod, setPaymentMethod] = useState('')

    const onConfirm = async () => {
        try {
            const data = { 
                orderId: order?.id, 
                payload: {
                    currentStatus: selectStatus 
                }
            }

            // Add paymentMethod if it's an Enaab order being completed without payment
            if (ENAAB_ID.includes(profile?.merchant?.id) &&
                order?.paymentStatus !== "PAID_ONLINE" &&
                selectStatus === "ORDER_COMPLETED" &&
                paymentMethod) {
                data.payload.paymentMethod = paymentMethod
            }

            await updateOrderStatus(data).unwrap()
            if (profile?.merchant?.role === ROLES.merchant) {
                dispatch(loadOrderDetails(order?.id));
            }
            setTimeout(() => {
                onClose()
            }, 2500);
        } catch (error) {

        }
    }

    useEffect(() => {
        if (!open) {
            reset()
            setSelectStatus('')
            setPaymentMethod('')
        }
    }, [open])

    const status = useMemo(() => {
        let failedStatus = []

        // if(order.orderType === "RETURN"){
        //     return orderReturnStatus
        // }
        
        if(["ORDER_ASSIGNED_TO_DRIVER_FOR_PICK_UP", "ORDER_ASSIGNED_TO_SHIPPING_COMPANY"].includes(order.currentStatus)) {
            failedStatus = ["ORDER_FAILED_TO_PICK_UP"]
        } else {
            failedStatus = ["ORDER_FAILED_TO_DROP_OFF"]
        }

        if (profile?.merchant?.role === ROLES.merchant || (profile?.role === ROLES.admin && order?.creator === ROLES.merchant && order?.deliveryType === "INTERNAL_DELIVERY")) {
            return [...orderStatus, ...failedStatus]
        }

        if (profile?.merchant?.shippingType === "FIRST_MILE" || (profile?.role === ROLES.admin && order?.merchant?.shippingType === "FIRST_MILE")) {
            return [...orderTaskStatus.slice(0, 3), ...failedStatus]
        } else if (profile?.merchant?.shippingType === "LAST_MILE" || (profile?.role === ROLES.admin && order?.merchant?.shippingType === "LAST_MILE")) {
            return [...orderTaskStatus.slice(1), ...failedStatus]
        }

        return [...orderTaskStatus, ...failedStatus]
    }, [profile, order])


    return (
        <Dialog
            open={open}
            onClose={(e) => e.preventDefault()}
            aria-labelledby="order-status-dialog-title"
            aria-describedby="order-status-dialog-description"
            fullWidth
        >
            <DialogTitle id="order-status-dialog-title">
                {t("Edit Order Status")}
            </DialogTitle>
            <Divider />
            <DialogContent>
                <FormControl size="small" fullWidth>
                    <InputLabel id="order-status-select-label">{t("Order Statuses")}</InputLabel>
                    <Select
                        labelId="order-status-select-label"
                        id="order-status-select"
                        value={selectStatus}
                        label={t("Order Statuses")}
                        onChange={(e) => setSelectStatus(e.target.value)}
                    >
                        {
                            status?.map((status) => (
                                <MenuItem key={status} value={status}>{t(status)}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>

                {ENAAB_ID.includes(profile?.merchant?.id) &&
                    order?.paymentStatus !== "PAID_ONLINE" &&
                    selectStatus === "ORDER_COMPLETED" && (
                    <Box sx={{ mt: 3 }}>
                        <FormControl component="fieldset" fullWidth>
                            <Typography variant="h6" sx={{ mb: 1.5 }}>
                                {t("Payment method")}
                            </Typography>
                            <RadioGroup
                                row
                                value={paymentMethod}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                            >
                                <FormControlLabel
                                    value="POS"
                                    control={<Radio />}
                                    label={"POS"}
                                />
                                <FormControlLabel
                                    value="COD"
                                    control={<Radio />}
                                    label={"COD"}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                )}
            </DialogContent>
            <Divider />
            <DialogActions>
                {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                {!!error && <Typography color="error">{t(error)}</Typography>}
                <Box mr="auto" />
                <Button
                    sx={{
                        textTransform: "none",
                    }}
                    variant='contained'
                    onClick={onClose}
                >
                    {t("Close")}
                </Button>
                <LoadingButton
                    disabled={!selectStatus}
                    loading={isLoading}
                    variant='contained'
                    sx={{
                        textTransform: "none",
                    }}
                    onClick={onConfirm}>
                    {t("Confirm")}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}